import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { LazyLog } from "react-lazylog";
import { TraceSpinner } from "react-spinners-kit";



const SystemLogsModal = (props) => {
  const { show, handleClose, container = {}, loading, setLoading, passphrase, API_URL } = props;
  const { url, container: containerName } = container;
  const [logs, setLogs] = useState(undefined);

  useEffect(() => {
    const fetchSystemHealthLogs = async () => {
      setLoading(true);
      setLogs(undefined);
      url && containerName && axios.get(`${API_URL}/logs/?url=${url}&container=${containerName}&passphrase=${passphrase}`)
        .then(res => {
          setLoading(false);
          const resLogs = unescape(res.data) || 'No data received'
          res && resLogs && setLogs(resLogs);
        })
        .catch((e) => {
          console.error(e);
        })
    };
    fetchSystemHealthLogs();
  }, [API_URL, containerName, passphrase, setLoading, url]);

  const onError = (error) => {
    console.error(error);
  };

  return (
    <>
      {!loading ? (
        <Modal
          show={show}
          onHide={handleClose}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {containerName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="health-log-modal-container">
              {logs !== undefined && (
                <LazyLog
                  text={logs}
                  onError={onError}
                  extraLines={1}
                  enableSearch
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      ) : <div className='health-log-modal-loading-spinner text-center'>
        <TraceSpinner />
      </div>}
    </>
  );
};

export default SystemLogsModal;
